export default "__VITE_ASSET__rC37LCbP__"